<template>
    <div class="msgBox">
        <div class="body" v-if="show">
            <transition name="msgbox">
                <div class="msgbox-container" :class="className">
                    <header>
                        <span  @click="cancelBtn"></span>
                    </header>
                    <div class="content-body" v-html="content">

                    </div>
                    <footer>
                        <a v-if="cancel" href="javascript:;" @click="cancelBtn" class="button">{{cancel}}</a>
                        <a href="javascript:;" @click="successBtn" >{{confirm}}</a>
                    </footer>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    export default {
        name: "msgBox",
        data() {
            return {
                show: false,
                title: '',
                content: '',
                confirm: '',
                cancel: '',
                className: ''
            }
        },
        watch: {
            show(val) {
                if (val) {
                    if (!this.hasClass(document.body, "pop-mask")) {
                        this.addClass(document.body, "pop-mask");
                    }
                } else {
                    this.removeClass(document.body, "pop-mask");
                }
            }
        },
        beforeMount() {
            //如果已经存在，则阻止出现第二次
            let node = document.querySelector('.msgbox-container');
            if (node && node.parentNode) {
                node.parentNode.removeChild(node)
            }
        },
        methods: {
            successBtn() {
                this.show = false;
            },
            cancelBtn() {
                this.show = false;
            },
            addClass(obj, cls) {
                var obj_class = obj.className,
                    blank = (obj_class != '') ? ' ' : '';
                var added = obj_class + blank + cls;
                obj.className = added;
            },
            removeClass(obj, cls) {
                var obj_class = ' ' + obj.className + ' ';
                obj_class = obj_class.replace(/(\s+)/gi, ' ');
                var removed = obj_class.replace(' ' + cls + ' ', ' ');
                removed = removed.replace(/(^\s+)|(\s+$)/g, '');
                obj.className = removed;//替换原来的 class.
            },
            hasClass(obj, cls) {
                var obj_class = obj.className,
                    obj_class_lst = obj_class.split(/\s+/);
                var x = 0;
                for (x in obj_class_lst) {
                    if (obj_class_lst[x] == cls) {
                        return true;
                    }
                }
                return false;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common";

    .body {
        position: fixed;
        width: @width;
        height: 100vh;
        background: #6565659c;
        left: 0;
        top: 0;
        z-index: 999999;
        display: flex;
        align-content: center;
        justify-content: center;
    }

    .msgbox-container {
        margin-top: 50%;
        width: 80%;
        background: @font-primary;
        .border-radius(10px);
        padding: 10px;
        height: 180px;
        /*  -webkit-transform:perspective(1px) translate(-50%, -50%) translate3d(1.5px, 1.5px,0);
          transform: perspective(1px)  translate(-50%, -50%) translate3d(1px, 1px,0);*/
        header {
            height: 17px;
            width: 100%;
            span {
                float: right;
                width: 25px;
                padding-left: 10px;
                height: 24px;
                background: url("@{sprite_personal}") no-repeat  9px -220px;
                background-size: 28px auto;
            }

        }
        .content-body {
            margin-bottom: 10px;
        }
        footer {
            width: 100%;
            text-align: center;
            /*display: block !important;*/
            display: flex;
            justify-content: center;
            align-content: center;
            a {
                .btn;
                width: 48%;
                &.button {
                    margin-right: 4%;
                    background: @subject_color;
                }

            }

        }
    }

    .msgbox-enter, .msgbox-leave-to {
        -webkit-transform: translate(-50%, -50%) scale(0, 0);
    }

    .msgbox-enter-active, .msgbox-leave-active {
        -webkit-transition: all .3s;
        transition: all .3s;
    }

    .msgbox-enter-to, .msgbox-leave {
        -webkit-transform: translate(-50%, -50%) scale(1, 1);

    }


</style>
